// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2ans0","header":"MergedInvoice_header__oM-b5"};